module.exports = __webpack_public_path__ + "img/Minie.e130b0d1.svg";